import { useAuthEventListener } from 'lib/auth';
import { clearOpenAIUser } from './identity';

export const useClearOpenAIUserOnLogout = () => {
  useAuthEventListener({
    onSignOutSuccess: () => {
      console.log('Clearing OpenAI User...');
      clearOpenAIUser();
    },
  });
};
